export const FeaturedAssets = (() => {
	'use strict';

	function init() {
	}

	return {
		init: init,
	};
})();
